import {Brick, registerBrick} from 'olympe';

export default class ReplaceAll extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} string
     * @param {string} substring
     * @param {string} newSubstring
     * @param {function(string)} setNewString
     */
    update($, [string, substring, newSubstring], [setNewString]) {
        setNewString(string.replaceAll(substring, newSubstring));
    }
}

registerBrick('017fbb11a8b46ca2356c', ReplaceAll);
